export default __webpack_public_path__ + "static/media/billings-dark-gnb.6defab02.svg";